import React from 'react';

import { ContactForm } from '~/components';

export const PageContact: React.FC = () => {
  return <ContactForm origin="Website" showBackToWebsite />;
};
